const localVars = {}

const ENVS = {
  development: {
    ...localVars,

    API_APP_KEY: '',
    API_BASE_URL: 'https://api.foguete.dev.redplatform.com.br/v1',
    ENVIRONMENT_ID: 'development',
    GTM_ID: '',
    GA4_ID: '',
    FB_PIXEL_ID: '',
    TTK_PIXEL_ID: '',
    TRACR_APP_KEY:
      '3790bcee95beac5ff3021d05b8bb1997abb17819b5bd49a5673d557225b7feff',
    TRACR_CLIENT_ID: 'foguete',
    STORYBLOK_ACCESS_TOKEN: 'rDOQ74EsKvkONZkUfzl86gtt',
  },

  staging: {
    ...localVars,

    API_APP_KEY: '',
    API_BASE_URL: 'https://api.foguete.stg.redplatform.com.br/v1',
    ENVIRONMENT_ID: 'staging',
    GTM_ID: '',
    GA4_ID: '',
    FB_PIXEL_ID: '',
    TTK_PIXEL_ID: '',
    TRACR_APP_KEY: '',
    TRACR_CLIENT_ID: '',
    STORYBLOK_ACCESS_TOKEN: 'uPXxc9QVIAQJ3zEE3LWyqwtt',
  },

  production: {
    ...localVars,

    API_APP_KEY: '',
    API_BASE_URL: 'https://api.foguete.redplatform.com.br/v1',
    ENVIRONMENT_ID: 'production',
    GTM_ID: 'GTM-WXGFD4DH',
    GA4_ID: 'G-7BEF6XZWSQ',
    FB_PIXEL_ID: '893665299320784',
    TTK_PIXEL_ID: 'CTRU1DRC77U1LI1DN5TG',
    TRACR_APP_KEY:
      '6a8a1fa343bae06596d356a746e75077b8174cab0f034cf5758085b5d6694695',
    TRACR_CLIENT_ID: 'foguete',
    STORYBLOK_ACCESS_TOKEN: 'xdIs5EjSKr4V391zlN30xgtt',
  }
}

export default ENVS[process.env.NEXT_PUBLIC_BUILD_ENV]
